export default "__VITE_ASSET__a8a02e11__"